<template>
  <section class="xb-section-container">
    <h2 class="underline">Directors/Partners Details</h2>
    <advanced-table
      v-if="tableData.length > 0"
      :is-fetching="isFetching"
      :columns="columns"
      :table-data="tableData"
      :paginated="false"
      :sticky="true"
    ></advanced-table>

    <span v-else>No directors/partners data available at the moment.</span>
  </section>
</template>

<script>
const mapState = window.Vuex.mapState;
import baseService from "./../../../services/index";
import { format, parseISO } from "date-fns";

export default {
  name: "DpDetails",
  data: () => {
    return {
      isFetching: false,
      columns: [
        {
          id: 1,
          label: "NRIC",
          dataCell: "nric",
          props: {
            sortable: false
          }
        },
        {
          id: 2,
          label: "Applicant Name",
          dataCell: "applicantName",
          props: {
            sortable: false
          }
        },
        {
          id: 21,
          label: "Role",
          dataCell: "role",
          props: {
            sortable: false
          }
        },
        {
          id: 3,
          label: "Submission Date and Time",
          dataCell: "submissionDate",
          props: {
            sortable: false
          },
          formatter: submissionDate =>
            submissionDate
              ? format(parseISO(submissionDate), "dd/MM/yyy HH:mm:ss")
              : "-"
        },
        {
          id: 4,
          label: "Status",
          dataCell: "workflowStatus",
          props: {
            sortable: false
          }
        },
        {
          id: 5,
          label: "Actions",
          type: "action",
          uniqueField: "referenceNo",
          items: [
            {
              id: 0,
              title: "View",
              icon: "eye",
              "icon-pack": "fa",
              events: ({ referenceNo }) => ({
                click: function() {
                  const baseUrl = `/aceas/EA-Management/`;
                  const routes = {
                    'LIC-ADD-DP': `${baseUrl}addition-of-director-partner-application/${referenceNo}/information`,
                    'LIC-REM-KEO': `${baseUrl}removal-of-KEO/${referenceNo}/application-information`,
                  };
                  const defaultRoute = `${baseUrl}director-partner-renewal/${referenceNo}/application-information`;

                  const route = referenceNo.includes('LIC-ADD-DP')
                    ? routes['LIC-ADD-DP']
                    : referenceNo.includes('LIC-REM-KEO')
                    ? routes['LIC-REM-KEO']
                    : defaultRoute;

                  window.location.href = route;
                },
              })
            }
          ]
        }
      ],
      total: 0,
      tableData: [],
      isFetchingSuccess: true
    };
  },
  computed: {
    ...mapState({
      apiConfig: state => state.config.configurationData,
      accessToken: state => state.auth.accessToken
    }),
    headerOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    }
  },
  mounted() {
    this.fetchTableData();
  },
  methods: {
    fetchTableData() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getDPRenewalListEndpoint;

      baseService(
        endpoint,
        {
          page: 1,
          pageSize: 20,
          sort: "applicantName",
          sortAscFlag: true,
          eaWorkspaceFlag: true
        },
        this.handleFetchTableDataSuccess,
        this.handleFailed,
        this.headerOptions
      );
    },
    handleFetchTableDataSuccess(response) {
      this.tableData = response.data.data;
      this.tableData.map(data => {
        data.badge = this.generateStatusBadge(data.workflowStatus);

        data.disabledTableIcons = [];

        if (data.workflowStatus === "Pending Applicant Submission") {
          data.disabledTableIcons.push("View");
        }
      });
    },
    handleFailed(e) {
      return e.message;
    },
    generateStatusBadge(statusValue) {
      const badgeObjectTemplate = {
        column: "workflowStatus",
        color: ""
      };

      switch (statusValue) {
        case "Pending EA Submission":
          badgeObjectTemplate.color = "#00a867";
          return badgeObjectTemplate;
        case "Pending Applicant Submission":
          badgeObjectTemplate.color = "#de5239";
          return badgeObjectTemplate;
        default:
          return {
            column: "",
            color: ""
          };
      }
    }
  }
};
</script>

<style></style>
